/**
 * Patch global fetch to attach x-acting-user-id from session for staff API calls.
 * Safe no-op when no session user is present (login, member portal, public pages).
 */

function readActingUserId() {
  try {
    const raw = sessionStorage.getItem("user-info");
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed?.user?._id || null;
  } catch {
    return null;
  }
}

export function installActingUserFetch() {
  if (typeof window === "undefined" || window.__gymxsActingUserFetchInstalled) return;
  window.__gymxsActingUserFetchInstalled = true;

  const originalFetch = window.fetch.bind(window);
  window.fetch = (input, init = {}) => {
    const actingUserId = readActingUserId();
    if (!actingUserId) {
      return originalFetch(input, init);
    }

    const headers = new Headers(init.headers || {});
    if (!headers.has("x-acting-user-id")) {
      headers.set("x-acting-user-id", String(actingUserId));
    }
    return originalFetch(input, { ...init, headers });
  };
}
